import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('paperwork', 'get-additional-info');

export const actions = createActions(consts);

export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'appointments',
  type: 'get',
  slug: [
    'questions',
    {
      type: 'payload.query',
      queryParameter: 'service_id',
      selector: 'serviceId',
    },
    {
      type: 'payload.query',
      queryParameter: 'organization_id',
      selector: 'organizationId',
    },
    {
      type: 'payload.query',
      queryParameter: 'patient_user_id',
      selector: 'patientUserId',
    },
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/paperwork/requests/paperwork-get-additional-info.js